/**
 * Table column configuration for onboarding list
 */

import { MRT_ColumnDef } from "mantine-react-table";
import { Button } from "@mantine/core";
import { OnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import { OnboardingData } from "./types";
import { EmptyCell } from "./components/EmptyCell";
import { toTitleCase, isEditableStatus } from "./utils/onboardingUtils";

interface CreateColumnsParams {
  buttonClassName: string;
  onMerchantClick: (
    status: OnboardingStatusEnum,
    merchantName: string,
    merchantEmail: string,
    merchantId: number
  ) => void;
}

export const createOnboardingColumns = ({
  buttonClassName,
  onMerchantClick,
}: CreateColumnsParams): MRT_ColumnDef<OnboardingData>[] => [
  {
    accessorKey: "merchantName",
    header: "Merchant Name",
    enableColumnFilter: true,
    Cell: ({ renderedCellValue }) => <EmptyCell value={renderedCellValue} />,
  },
  {
    accessorKey: "merchantEmail",
    header: "Merchant Email",
    enableColumnFilter: true,
    Cell: ({ renderedCellValue }) => <EmptyCell value={renderedCellValue} />,
  },
  {
    accessorKey: "onboardingStatus",
    header: "KYC Status",
    enableColumnFilter: true,
    filterFn: "equals",
    filterVariant: "select",
    mantineFilterSelectProps: {
      data: Object.values(OnboardingStatusEnum).map((status) => ({
        value: status,
        label: toTitleCase(status),
      })),
    },
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();
      return <EmptyCell value={value ? toTitleCase(value) : null} />;
    },
  },
  {
    accessorKey: "action",
    header: "Action",
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => {
      const isEditable = isEditableStatus(row.original.onboardingStatus);
      return (
        <Button
          variant="outline"
          color={isEditable ? "blue" : "gray"}
          size="xs"
          w={60}
          className={buttonClassName}
          onClick={() =>
            onMerchantClick(
              row.original.onboardingStatus,
              row.original.merchantName,
              row.original.merchantEmail,
              row.original.merchantId ?? 0
            )
          }
          aria-label={`${isEditable ? "Edit" : "View"} onboarding for ${
            row.original.merchantName
          }`}
        >
          {isEditable ? "Edit" : "View"}
        </Button>
      );
    },
  },
];
